import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-add-class-support-article',
    template: `
        <ng-container i18n="@@support.articles.addClass">
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/classes">Classes Overview</a>.</span>
                </li>
                <li>
                    <span>Click the <strong>Add a class</strong> button.</span>
                </li>
                <li>
                    <span>
                        Fill in the form.
                        <br/>
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/addClass.png"/>

                        <ul>
                            <li>
                                <span><strong>Class name:</strong> name the class as clearly as possible.</span>
                            </li>
                            <li>
                                <span>
                                    <strong>Instructors:</strong> (optional field) if you want to link instructors to this class you can select them here. They can then follow the students of this class.
                                     If the instructors are not in the list yet, create them first.
                                    <br/><br/>
                                    <a routerLink="/support/organizations/instructors/add" mat-stroked-button
                                       color="primary" class="supportLink">Add an instructor</a>
                                </span>
                            </li>
                        </ul>
                    </span>
                </li>
                <li>
                    <span>After saving you can choose to either enroll students in the class or to add another class. You can also close the dialog box to return to the Classes Overview.</span>
                </li>
            </ol>
        </ng-container>
    `
})
export class AddClassSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
